import { OrderLineItemType, OrderLinePublicType } from "@smeetz/orders";
import { PCTypes } from "@/types/db/product-category";

export function mapPcTypeToOrderLineType(
  pcType: PCTypes | string
): OrderLinePublicType {
  switch (pcType) {
    case PCTypes.Retail:
    case PCTypes[PCTypes.Retail]:
    case PCTypes.Merchandising:
    case PCTypes[PCTypes.Merchandising]:
      return OrderLinePublicType.RETAIL;

    case PCTypes.Event:
    case PCTypes[PCTypes.Event]:
    case PCTypes.Recurring:
    case PCTypes[PCTypes.Recurring]:
      return OrderLinePublicType.TICKET;

    case PCTypes.Seated:
    case PCTypes[PCTypes.Seated]:
    case PCTypes.SeatedPass:
    case PCTypes[PCTypes.SeatedPass]:
    case PCTypes.SeatedSub:
    case PCTypes[PCTypes.SeatedSub]:
      return OrderLinePublicType.SEATED;

    case PCTypes.Membership:
    case PCTypes[PCTypes.Membership]:
      return OrderLinePublicType.MEMBERSHIP;

    case PCTypes.MembershipVoucher:
    case PCTypes[PCTypes.MembershipVoucher]:
      return OrderLinePublicType.MEMBERSHIP_VOUCHER;

    case PCTypes.MembershipSeated:
    case PCTypes[PCTypes.MembershipSeated]:
      return OrderLinePublicType.MEMBERSHIP_SEATED;

    case PCTypes.GiftCard:
    case PCTypes[PCTypes.GiftCard]:
      return OrderLinePublicType.VOUCHER;

    default:
      return OrderLinePublicType.TICKET; // TODO: confirm this
  }
}

export function mapPcTypeToOrderLineItemType(
  pcType: PCTypes | string
): OrderLineItemType {
  // Normalize string names to numeric PCTypes value
  const t =
    typeof pcType === "string"
      ? PCTypes[pcType as keyof typeof PCTypes]
      : pcType;

  switch (t) {
    case PCTypes.Normal:
      return OrderLineItemType.NORMAL;
    case PCTypes.GiftCard:
      return OrderLineItemType.GIFT_CARD;
    case PCTypes.SeatedSub:
      return OrderLineItemType.SEATED_SUB;
    case PCTypes.Seated:
      return OrderLineItemType.SEATED;
    case PCTypes.Plugin:
      return OrderLineItemType.PLUGIN;
    case PCTypes.Google:
      return OrderLineItemType.GOOGLE;
    case PCTypes.Merchandising:
      return OrderLineItemType.MERCHANDISING;
    case PCTypes.EventPass:
      return OrderLineItemType.EVENT_PASS;
    case PCTypes.Event:
      return OrderLineItemType.EVENT;
    case PCTypes.SeatedPass:
      return OrderLineItemType.SEATED_PASS;
    case PCTypes.AddOn:
      return OrderLineItemType.ADD_ON;
    case PCTypes.Donation:
      return OrderLineItemType.DONATION;
    case PCTypes.Bundle:
      return OrderLineItemType.BUNDLE;
    case PCTypes.LightQuantity:
      return OrderLineItemType.LIGHT_QUANTITY;
    case PCTypes.Membership:
      return OrderLineItemType.MEMBERSHIP;
    case PCTypes.OVV:
      return OrderLineItemType.OVV;
    case PCTypes.MembershipVoucher:
      return OrderLineItemType.MEMBERSHIP_VOUCHER;
    case PCTypes.MembershipSeated:
      return OrderLineItemType.MEMBERSHIP_SEATED;
    case PCTypes.Recurring:
      return OrderLineItemType.RECURRING;
    case PCTypes.Retail:
      return OrderLineItemType.RETAIL;
    default:
      throw new Error(`Unsupported PCTypes: ${pcType}`);
  }
}
